import { GenericStatus, GenericStatusColorType } from '@hevoio/hevo-ui-toolkit';
import { DestinationStatus } from '../interfaces/destination';

export const DESTINATION_RENDERED_STATUSES = {
  FAILED: 'Failed',
  CREATED: 'Created',
  DELETING: 'Deleting...',
  DELETED: 'Deleted'
};

export const DESTINATION_RENDERED_STATUSES_VALUES = {
  [DestinationStatus.CREATED]: 'CREATED',
  [DestinationStatus.FAILED]: 'FAILED',
  [DestinationStatus.DELETE_FAILED]: 'FAILED',
  [DestinationStatus.DELETING]: 'DELETING',
  [DestinationStatus.DELETED]: 'DELETED'
};

export const DESTINATION_FILTER_STATUSES = Object.entries(DESTINATION_RENDERED_STATUSES)
  .filter(([k]) => !['DELETING', 'DELETED'].includes(k))
  .map(([k, v]) => {
    return {
      label: v,
      value: k
    };
  });

export const DESTINATION_STATUS_DATA_MAP: {
  [key in DestinationStatus]: GenericStatus<DestinationStatus>;
} = {
  [DestinationStatus.FAILED]: {
    value: DestinationStatus.FAILED,
    displayName: DESTINATION_RENDERED_STATUSES.FAILED,
    colorType: GenericStatusColorType.ERROR
  },
  [DestinationStatus.CREATED]: {
    value: DestinationStatus.CREATED,
    displayName: DESTINATION_RENDERED_STATUSES.CREATED,
    colorType: GenericStatusColorType.DEFAULT
  },
  [DestinationStatus.DELETING]: {
    value: DestinationStatus.DELETING,
    displayName: DESTINATION_RENDERED_STATUSES.DELETING,
    colorType: GenericStatusColorType.ERROR
  },
  [DestinationStatus.DELETED]: {
    value: DestinationStatus.DELETED,
    displayName: DESTINATION_RENDERED_STATUSES.DELETED,
    colorType: GenericStatusColorType.ERROR
  },
  [DestinationStatus.DELETE_FAILED]: {
    value: DestinationStatus.DELETE_FAILED,
    displayName: DESTINATION_RENDERED_STATUSES.FAILED,
    colorType: GenericStatusColorType.ERROR
  }
};
